import CreatMindItmeData from "../views/uidata/CreatMindItmeData";
import Strings from "./lang/strings";
import getString from "./lang/language";
import NodeLayoutType from "../viewmodel/datatype/NodeLayoutType";
import MindType from "../viewmodel/datatype/MindType";
import LineLayout from "../viewmodel/datatype/LineLayout";
import MindDisplayType from "../viewmodel/datatype/MindDisplayType";
import strings from "./lang/strings";

//创建导图的数据
var templateData = [];

var creatMindTypeLeftRight = [];
var creatMindTypeUnilateral = [];
var creatMindTypeBottom = [];
var creatMindTypeBubble = [];
var creatMindTypeTimeVertical = [];


function createdType() {
    creatMindTypeLeftRight.push(
      new CreatMindItmeData(
        "left_right_layout_empty.jpg",
        Strings.My_Mind_Type_Left_Right,
        NodeLayoutType.LAYOUT_RIGHT_LEFT_CLOCKWISE,
        MindType.LINE_MAP,
        1.333,
        3,
        LineLayout.CURVE_LINE_2,
        MindDisplayType.MindMap,
        true
      )
    );
    creatMindTypeLeftRight.push(
      new CreatMindItmeData(
        "left_right_layout_7.png",
        "双向导图",
        NodeLayoutType.LAYOUT_RIGHT_LEFT_CLOCKWISE,
        MindType.LINE_MAP,
        1.333,
        37,
        LineLayout.CURVE_LINE,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Left_Right_Focus_Modol)
      )
    );
    creatMindTypeLeftRight.push(
      new CreatMindItmeData(
        "free_tree_layout_1.png",
        "双向导图",
        NodeLayoutType.LAYOUT_FREE_TREE,
        MindType.LINE_MAP,
        1.333,
        38,
        LineLayout.CURVE_LINE,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Left_Right_Free_Modol)
      )
    );
    creatMindTypeLeftRight.push(
      new CreatMindItmeData(
        "left_right_layout_3.png",
        "双向导图",
        NodeLayoutType.LAYOUT_RIGHT_LEFT_CLOCKWISE,
        MindType.LINE_MAP,
        1.333,
        2,
        LineLayout.FULL_RIGHT_ANGLE_CORNER_LINE,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Left_Right_Neat_Modol)
      )
    );
    creatMindTypeLeftRight.push(
      new CreatMindItmeData(
        "left_right_layout_5.png",
        "双向导图",
        NodeLayoutType.LAYOUT_RIGHT_LEFT_CLOCKWISE,
        MindType.LINE_MAP,
        1.333,
        22,
        LineLayout.CURVE_LINE_2,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Left_Right_Fresh_Modol)
      )
    );
    creatMindTypeLeftRight.push(
      new CreatMindItmeData(
        "left_right_layout_4.png",
        "双向导图",
        NodeLayoutType.LAYOUT_TREE_LEFT_RIGHT,
        MindType.LINE_MAP,
        1.333,
        21,
        LineLayout.RIGHT_ANGLE_LINE,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Tree_Left_Right_Modol)
      )
    );

    creatMindTypeUnilateral.push(
      new CreatMindItmeData(
        "card_layout_1.jpg",
        Strings.My_Mind_Type_Unilateral,
        NodeLayoutType.LAYOUT_RIGHT,
        MindType.LINE_MAP,
        1.333,
        39,
        LineLayout.FULL_RIGHT_ANGLE_CORNER_LINE,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Left_Right_Card_Modol)
      )
    );

    creatMindTypeUnilateral.push(
      new CreatMindItmeData(
        "layout_right_3.png",
        Strings.My_Mind_Type_Unilateral,
        NodeLayoutType.LAYOUT_FISH_RIGHT,
        MindType.LINE_MAP,
        1.333,
        5,
        LineLayout.CURVE_LINE_2,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Fish_Modol)
      )
    );
    creatMindTypeUnilateral.push(
      new CreatMindItmeData(
        "layout_bridge_1.png",
        Strings.My_Mind_Type_Unilateral,
        NodeLayoutType.LAYOUT_BRIDGE,
        MindType.TIME_MAP,
        1.333,
        5,
        LineLayout.CURVE_LINE_2,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Bridge_Modol)
      )
    );
    
    creatMindTypeUnilateral.push(
      new CreatMindItmeData(
        "layout_right_2.png",
        "逻辑图",
        NodeLayoutType.LAYOUT_BRACKETS_RIGHT,
        MindType.LINE_MAP,
        1.333,
        36,
        LineLayout.RIGHT_ANGLE_CORNER_LINE,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Brackets_Right_Modol)
      )
    );

    creatMindTypeUnilateral.push(
      new CreatMindItmeData(
        "layout_radiate_1.png",
        "逻辑图",
        NodeLayoutType.LAYOUT_RADIATE,
        MindType.LINE_MAP,
        1.333,
        36,
        LineLayout.CURVE_LINE,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Radiate_Modol)
      )
    );
    creatMindTypeUnilateral.push(
      new CreatMindItmeData(
        "layout_right_1.png", 
        "逻辑图",
        NodeLayoutType.LAYOUT_RIGHT,
        MindType.LINE_MAP,
        1.333,
        6,
        LineLayout.STRAIGHT_LINE_2,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Right_Modol)
      )
    );
    creatMindTypeUnilateral.push(
      new CreatMindItmeData(
        "form_horizontal_layout_1.png",
        "逻辑图",
        NodeLayoutType.LAYOUT_FORM_HORIZONTAL,
        MindType.LINE_MAP,
        1.333,
        5,
        LineLayout.RIGHT_ANGLE_CORNER_LINE,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Form_Modol)
      )
    );
    creatMindTypeUnilateral.push(
      new CreatMindItmeData(
        "layout_right_5.png",
        "逻辑图",
        NodeLayoutType.LAYOUT_LEFT,
        MindType.LINE_MAP,
        1.333,
        25,
        LineLayout.CURVE_LINE_AVERAGE,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Left_Modol)
      )
    );
    creatMindTypeUnilateral.push(
      new CreatMindItmeData(
        "layout_right_4.png",
        "逻辑图",
        NodeLayoutType.LAYOUT_HORIZONTAL_RIGHT,
        MindType.LINE_MAP,
        1.333,
        23,
        LineLayout.RIGHT_ANGLE_LINE,
        MindDisplayType.MindMap,
        false,        
        getString(strings.My_Mind_Horizontal_Right_Modol)
      )
    );
    creatMindTypeUnilateral.push(
      new CreatMindItmeData(
        "layout_right_6.png",
        "逻辑图",
        NodeLayoutType.LAYOUT_TREE_RIGHT,
        MindType.LINE_MAP,
        1.333,
        24,
        LineLayout.FULL_RIGHT_ANGLE_CORNER_LINE,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Tree_Right_Modol)
      )
    );

    creatMindTypeBottom.push(
      new CreatMindItmeData(
        "layout_bottom_1.png",
        Strings.My_Mind_Type_Bottom,
        NodeLayoutType.LAYOUT_BOTTOM,
        MindType.LINE_MAP,
        1.333,
        9,
        LineLayout.RIGHT_ANGLE_CORNER_LINE,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Bottom_Modol)
      )
    );
    creatMindTypeBottom.push(
      new CreatMindItmeData(
        "layout_bottom_2.png",
        "组织架构图",
        NodeLayoutType.LAYOUT_BOTTOM,
        MindType.LINE_MAP,
        1.333,
        10,
        LineLayout.RIGHT_ANGLE_CORNER_LINE,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Bottom_Modol)
      )
    );
    creatMindTypeBottom.push(
      new CreatMindItmeData(
        "layout_bottom_3.png",
        "组织架构图",
        NodeLayoutType.LAYOUT_BOTTOM,
        MindType.LINE_MAP,
        1.333,
        11,
        LineLayout.RIGHT_ANGLE_CORNER_LINE,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Bottom_Modol)
      )
    );
    creatMindTypeBottom.push(
      new CreatMindItmeData(
        "layout_bottom_4.png",
        "组织架构图",
        NodeLayoutType.LAYOUT_BOTTOM,
        MindType.LINE_MAP,
        1.333,
        26,
        LineLayout.FULL_RIGHT_ANGLE_CORNER_LINE,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Bottom_Modol)
      )
    );
    
    creatMindTypeBottom.push(
      new CreatMindItmeData(
        "layout_bottom_5.png",
        "组织架构图",
        NodeLayoutType.LAYOUT_TOP,
        MindType.LINE_MAP,
        1.333,
        27,
        LineLayout.FULL_RIGHT_ANGLE_CORNER_LINE,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Top_Modol)
      )
    );
    creatMindTypeBottom.push(
      new CreatMindItmeData(
        "layout_bottom_6.png",
        "组织架构图",
        NodeLayoutType.LAYOUT_TOP,
        MindType.LINE_MAP,
        1.333,
        28,
        LineLayout.RIGHT_ANGLE_LINE,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Top_Modol)
      )
    );

    creatMindTypeBubble.push(
      new CreatMindItmeData(
        "bubble_layout_1.svg",
        Strings.My_Mind_Type_Bubble,
        NodeLayoutType.LAYOUT_BUBBLE,
        MindType.BUBBLE_MAP,
        1.333,
        4,
        LineLayout.STRAIGHT_LINE,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Bubble_Modol)
      )
    );
    creatMindTypeBubble.push(
      new CreatMindItmeData(
        "circular_layout.svg",
        "气泡图",
        NodeLayoutType.LAYOUT_CIRCLE,
        MindType.LINE_MAP,
        1.333,
        7,
        LineLayout.STRAIGHT_LINE,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Circular_Modol)
      )
    );
    creatMindTypeBubble.push(
      new CreatMindItmeData(
        "double_bubble_layout_1.svg",
        "气泡图",
        NodeLayoutType.LAYOUT_RIGHT_LEFT_CLOCKWISE,
        MindType.DOUBLE_BUBBLE_MAP,
        1.333,
        0,
        LineLayout.STRAIGHT_LINE,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Double_Bubble_Modol)
      )
    );
    creatMindTypeBubble.push(
      new CreatMindItmeData(
        "double_bubble_layout_2.svg",
        "气泡图",
        NodeLayoutType.LAYOUT_RIGHT_LEFT_CLOCKWISE,
        MindType.DOUBLE_BUBBLE_MAP,
        1.333,
        29,
        LineLayout.STRAIGHT_LINE,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Double_Bubble_Modol)
      )
    );
    creatMindTypeBubble.push(
      new CreatMindItmeData(
        "bubble_layout_4.svg",
        "气泡图",
        NodeLayoutType.LAYOUT_BUBBLE,
        MindType.BUBBLE_MAP,
        1.333,
        30,
        LineLayout.STRAIGHT_LINE,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Bubble_Modol)
        
      )
    );
    creatMindTypeBubble.push(
      new CreatMindItmeData(
        "bubble_layout_5.svg",
        "气泡图",
        NodeLayoutType.LAYOUT_BUBBLE,
        MindType.BUBBLE_MAP,
        1.333,
        31,
        LineLayout.STRAIGHT_LINE,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Bubble_Modol)
      )
    );

    creatMindTypeTimeVertical.push(
      new CreatMindItmeData(
        "vertical_layout_1.jpg",
        Strings.My_Mind_Type_Time_Vertical,
        NodeLayoutType.LAYOUT_VERTICAL,
        MindType.TIME_MAP,
        1,
        12,
        LineLayout.STRAIGHT_LINE,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Time_Vertical_Modol)
      )
    );
    creatMindTypeTimeVertical.push(
      new CreatMindItmeData(
        "vertical_layout_3.jpg",
        "日程安排图",
        NodeLayoutType.LAYOUT_HORIZONTAL,
        MindType.TIME_MAP,
        1,
        12,
        LineLayout.STRAIGHT_LINE,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Time_Horizontal_Modol)
      )
    );
    creatMindTypeTimeVertical.push(
      new CreatMindItmeData(
        "vertical_layout_2.jpg",
        "日程安排图",
        NodeLayoutType.LAYOUT_HORIZONTAL_S,
        MindType.TIME_MAP,
        1,
        12,
        LineLayout.STRAIGHT_LINE,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Time_S_Horizontal_Modol)
      )
    );
    creatMindTypeTimeVertical.push(
      new CreatMindItmeData(
        "vertical_layout_4.png",
        "日程安排图",
        NodeLayoutType.LAYOUT_HORIZONTAL,
        MindType.TIME_MAP,
        1,
        32,
        LineLayout.STRAIGHT_LINE,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Time_Horizontal_Modol)
      )
    );
    creatMindTypeTimeVertical.push(
      new CreatMindItmeData(
        "vertical_layout_5.png",
        "日程安排图",
        NodeLayoutType.LAYOUT_VERTICAL,
        MindType.TIME_MAP,
        1,
        33,
        LineLayout.STRAIGHT_LINE,
        MindDisplayType.MindMap,
        false,
        getString(strings.My_Mind_Time_Vertical_Modol)
      )
    );
    //creatMindTypeTimeVertical.push(new CreatMindItmeData( 'vertical_layout_6.png', '日程安排图', NodeLayoutType.LAYOUT_HORIZONTAL_S, MindType.TIME_MAP, 1, 34))

    templateData.push(creatMindTypeLeftRight);
    templateData.push(creatMindTypeUnilateral);
    templateData.push(creatMindTypeBottom);
    templateData.push(creatMindTypeBubble);
    templateData.push(creatMindTypeTimeVertical);

    for (let i = 0; i < templateData.length; i++) {
      for (let j = 0; j < templateData[i].length; j++) {
        if (templateData[i][j] != null) {
          templateData[i][
            j
          ].icon = require("../../static/img/mapIcon/res/mipmap-xxhdpi/" +
            templateData[i][j].icon);
        }
      }
    }
  }

  createdType();

export default templateData